module.exports = __webpack_public_path__ + "img/instagram.202cfe0a.svg";